import { APIInstance } from "./api.config";

const { api } = new APIInstance({ path: "/v1/files" });

export const FileService = {
  /**
   * Fetches a fresh, short-lived (5-minute) signed URL for a private file.
   * @param {number|string} fileId - The ID of the file to fetch
   * @returns {Promise<any>} - The file record (id, originalName, mimeType, url, ...)
   */
  getFileDetails: async (fileId: number | string) => {
    const { data } = await api.get(`/${fileId}`);
    return data;
  },
};
